import { Flex } from '@mantine/core';
import './BlogCard.css'
import { Link } from 'react-router-dom'
import { getExcerpt } from '../../../utils/getExcerpt'
import moment from 'moment';
import { getRelativeDate } from '../../../utils/getRelativeDate';

export default function BlogCard({ isLatest, item, idx }) {

   if (isLatest) return (
      <Link
         className='BlogCard-latest-container'
         style={{ display: 'flex' }}
         to={`/blog/${item.slugName}`}
         key={item._id}
      >
         <article className='BlogCard-latest-wrapper'>
            <img
               className='BlogCard-latest-image'
               src={item.image}
               alt={item.title}
            />

            <div className='BlogCard-latest-contentWrapper'>
               <Flex align='center' justify='flex-start' gap={4}>
                  <span className='BlogCard-latest--date'>{getRelativeDate(item.date)}</span>
                  {item.author && <span className='BlogCard-latest--date'>- por <strong>{item.author}</strong></span>}
               </Flex>

               <h2 className='BlogCard-latest--title'>{item.title}</h2>
               <p className='Blogcard-latest-description'>
                  {getExcerpt(item.content, idx === 0 ? 240 : 160)}
               </p>
            </div>
         </article>
      </Link>
   )

   return (
      <Link to={`/blog/${item._id}`} key={item._id}>
         <article className='BlogCard-general-container'>
            {item.image && <img
               className='BlogCard-general-image'
               src={item.image}
               alt={item.title}
            />}

            <div className='BlogCard-general-contentWrapper'>
               <Flex align='center' justify='flex-start' gap={4}>
                  <span className='BlogCard-latest--date'>{getRelativeDate(item.date)}</span>
                  {item.author && <span className='BlogCard-latest--date'>- por <strong>{item.author}</strong></span>}
               </Flex>

               <h2 className='BlogCard-general--title'>{item.title}</h2>
               <p className='Blogcard-general-description'>
                  {getExcerpt(item.content, 160)}
               </p>
            </div>
         </article>
      </Link>
   )
}